'use strict';

const DashDialogsController = function ($scope, $rootScope, $state, $window, Flux, DashDialogsActions, AppDialogsActions, IdentityService, AnalyticsService) {

  const vm = this;
  const PlanStore = Flux.Store.get('PlanStore');
  const SiteStore = Flux.Store.get('SiteStore');

  vm.position = 'center';
  vm.alignment = 'top right';

  vm.showDialog = false;
  vm.show = false;
  vm.view;
  vm.loading = false;
  vm.state = $state.current.name;
  vm.siteSlugChanged = '';


  const user = IdentityService.get('user');
  vm.hasMultipleOrganizations = user && user.organizations ? user.organizations.length > 1 : false;

  const DashDialogsStore = Flux.Store.get('DashDialogsStore');

  vm.isAdmin = IdentityService.isOrganizationAdmin();
  vm.isAdminBilling = IdentityService.isOrganizationBillingAdmin();

  vm.expiredConvertToSubscription = () => {

    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': 0,
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  /**
   * Navigation Functions
   *
   */

  vm.goToBilling = () => {

    if (vm.isAdmin) {
      $state.go('settings.organization.billing');
    }
    else {
      vm.closeModal();
    }
  };

  vm.goToSettings = () => {

    vm.loading = true;
    $state.go('settings.myProfile');
  };


  vm.closeModal = () => {

    vm.showDialog = false;
    vm.show = false;
  };

  vm.openDialog = () => {

    vm.projectPlan = PlanStore.get('current');
    vm.siteSlugChanged = DashDialogsStore.get('siteSlugChanged');
    vm.view = DashDialogsStore.get('view');
    vm.show = true;
  };

  vm.hideDialog = () => {

    vm.show = false;
  };

  vm.logout = () => {

    $state.go('logout', {}, {
      location: false
    });
  };

  vm.changeOrg = () => {

    $state.go('select-organization');
  };

  vm.reloadSlugChanged = () => {

    vm.loading = true;

    const slug = vm.siteSlugChanged.slug;

    $state.go('dash.map', {
      siteName: slug,
      changeToLocation: `site/${slug}`,
      urlUpdate: false
    }, {
      notify: false,
      reload: true
    });

    vm.closeModal();
  };

  vm.reloadSiteDeleted = () => {

    $window.location.href = '/';
  };

  DashDialogsStore.on(DashDialogsStore.Events.OpenDialog, vm.openDialog.bind(vm), $scope);
};

DashDialogsController.$inject = [
  '$scope', '$rootScope', '$state', '$window', 'sbFlux', 'DashDialogsActions',
  'AppDialogsActions', 'IdentityService', 'AnalyticsService'
];
module.exports = DashDialogsController;



// WEBPACK FOOTER //
// ./src/app/dash/dialogs/DashDialogsController.js